<div>
    <!-- <progress [ngClass]="progressType" [value]="value" [max]="max"></progress> -->
    <div class="progress">
        <div class="progress-bar progress-bar-striped bg-{{progressType}} progress-bar-animated" role="progressbar" [ngStyle]="{'width': value+'%'}" [attr.aria-valuenow]="value"
            [attr.aria-valuemin]="0" [attr.aria-valuemax]="100"></div>
    </div>
</div>